import { Injectable } from '@angular/core';
import { selectUrlParams } from '../../url-params/url-params.selector';
import { AppState } from '../../../app.state';
import { Store } from '@ngrx/store';
import { Globals } from '../../../app.globals';

@Injectable()
export class UrlParamsService {
    private isGeorge4BClientId: boolean;
    constructor(
        private store: Store<AppState>,
    ) {
        this.store.select(selectUrlParams)
            .subscribe(urlParams => {
                this.isGeorge4BClientId = urlParams && urlParams.state && urlParams.state.srcClientId === Globals.georgeBusinessClientId;
            });
    }
    public isGeorge4B() {
        return this.isGeorge4BClientId;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/services/urlParams.service.ts